import { Typography, Box } from '@mui/material'
import React from 'react'
import theme from 'theme/ThemeContext'

const CustomLabelForm = ({
    variant,
    label,
    required,
    ...rest
}) => {
    let displayLabel = label;
    let isRequired = Boolean(required);

    if (typeof label === 'string' && /\s*\*+\s*$/.test(label)) {
        displayLabel = label.replace(/\s*\*+\s*$/, '');
        isRequired = true;
    }

    return (
        <Typography 
            variant={variant} 
            gutterBottom 
            sx={{ color: theme.palette.text.primary, fontWeight: 500 }}
            {...rest}
        >
            {displayLabel}
            {isRequired && (
                <Box component="span" sx={{ color: '#d32f2f', ml: 0.5, fontWeight: 'bold' }}>
                    *
                </Box>
            )}
        </Typography>
    )
}

export default CustomLabelForm

